import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { incomeTypes, ModalDialogType } from 'src/app/@core/constants';
import { PosConfirmationService } from 'src/app/@core/services/pos-confirmation.service';
import { Customer } from 'src/app/models/customer';
import { OnbaseCatalogue } from 'src/app/models/onbase-catalogue';
import { OnbaseService } from 'src/app/services/onbase.service';

@Component({
  selector: 'app-person-income-information-step',
  templateUrl: './person-income-information-step.component.html',
  styleUrls: ['./person-income-information-step.component.sass']
})
export class PersonIncomeInformationStepComponent implements OnInit {

  constructor(private fb: FormBuilder, private confirmService: PosConfirmationService, private onbaseService: OnbaseService) {
    this.personIncomeInformationForm = this.fb.group({
      incomeType: new FormControl("", Validators.required),
      incomeForm: new FormGroup({}, Validators.required)
    });
  }

  @Input() personIncomeInformationForm = new FormGroup({
    incomeType: new FormControl("", Validators.required),
    incomeForm: new FormGroup({}, Validators.required)
  });

  @Input() onbaseCatalogue: OnbaseCatalogue = new OnbaseCatalogue();
  @Input() customerType: string = "PERSON";
  @Input() customer: Customer = new Customer();
  @Input() isEdit: boolean = false;
  @Input() hideStreet: boolean = false;
  @Input() readonly = false;
  filteredIncomeTypes: Array<{ code: string, customerType: string, description: string }> = [];
  private currentValue = "";
  @Input() isShortFormActiveForPlan = false;
  async ngOnInit(): Promise<void> {
    if (this.onbaseCatalogue.economicActivity.length == 0) {
      this.onbaseCatalogue = (await this.onbaseService.readOnBaseCatalogue().toPromise()).response;
    }
    this.filteredIncomeTypes = incomeTypes.filter(f => f.customerType == this.customerType);

  }

  async changeIncomeType(event: { code: string, customerType: string, description: string }) {

    // if (this.currentValue) {
    //   const result = await this.confirmService.showAsync("Advertencia", "¿Ya existe información de ingreso para esta solicitud, se eliminarán los campos, esta seguro que desea continuar?", ModalDialogType.WARNING);
    //   if (!result) {
    //     this.personIncomeInformationForm.get("incomeType")?.setValue(this.currentValue);
    //     return;
    //   }
    // }
    this.initializeForm(event);
    // this.currentValue = event.code;
  }

  private initializeForm(event: { code: string; customerType: string; description: string; }) {
    console.log(event);
    switch (event.code) {
      case 'Z000':
        this.personIncomeInformationForm.setControl("incomeForm", this.fb.group({
          companyType: new FormControl("", this.isShortFormActiveForPlan ? []: [Validators.required]),
          companyName: new FormControl("", Validators.required),
          monthlySalaryAmount: new FormControl("0", [Validators.min(1), Validators.required]),
          startDate: new FormControl("", Validators.required),
          workContractType: new FormControl("", this.isShortFormActiveForPlan ? []: [Validators.required]),
          workDepartmentName: new FormControl("", Validators.required),
          workPosition: new FormControl("", this.isShortFormActiveForPlan ? []: [Validators.required]),
          country: new FormControl(this.customer.mainPersonalInfo?.nationality, Validators.required),
          deparment: new FormControl("", Validators.required),
          city: new FormControl("", Validators.required),
          neighborhood: new FormControl("", Validators.required),
          companyPhone: new FormControl("", this.isShortFormActiveForPlan ? []: [Validators.required]),
          companyExtension: new FormControl(""),
        }));
        if (!this.hideStreet) {
          let incomeForm = this.personIncomeInformationForm.get("incomeForm") as FormGroup;
          incomeForm.addControl("street", new FormControl("", Validators.required));
          incomeForm.addControl("street2", new FormControl(""));
          incomeForm.addControl("street3", new FormControl(""));
          incomeForm.addControl("street4", new FormControl(""));
          incomeForm.addControl("street5", new FormControl(""));
        }
        break;
      case 'Z001':
        this.personIncomeInformationForm.setControl("incomeForm", this.fb.group({
          businessName: new FormControl("", this.isShortFormActiveForPlan ? []: [Validators.required]),
          incomeAmount: new FormControl("0", [Validators.min(1), Validators.required]),
          economicActivity: new FormControl("", Validators.required),
          businessRelationType: new FormControl("", Validators.required),
          businessRelationDate: new FormControl("", Validators.required),
          country: new FormControl(this.customer.mainPersonalInfo?.nationality, Validators.required),
          deparment: new FormControl("", Validators.required),
          city: new FormControl("", Validators.required),
          neighborhood: new FormControl("", Validators.required),
          companyPhone: new FormControl("", Validators.required),
          companyExtension: new FormControl(""),
        }));
        if (!this.hideStreet) {
          let incomeForm = this.personIncomeInformationForm.get("incomeForm") as FormGroup;
          incomeForm.addControl("street", new FormControl("", Validators.required));
          incomeForm.addControl("street2", new FormControl(""));
          incomeForm.addControl("street3", new FormControl(""));
          incomeForm.addControl("street4", new FormControl(""));
          incomeForm.addControl("street5", new FormControl(""));
        }
        break;
      case 'Z002':
        this.personIncomeInformationForm.setControl("incomeForm", this.fb.group({
          incomeAmount: new FormControl("0", this.isShortFormActiveForPlan ? [Validators.min(0)] : [Validators.min(1), Validators.required]),
          remittanceName: new FormControl("", Validators.required),
          familyRelationship: new FormControl("", Validators.required),
          incomeOrigin: new FormControl("", Validators.required),
          receivingDate: new FormControl("", this.isShortFormActiveForPlan ? []: [Validators.required])
        }))
        console.log(this.personIncomeInformationForm);
        
        break;
      case 'Z003':
        this.personIncomeInformationForm.setControl("incomeForm", this.fb.group({
          companyType: new FormControl(""),
          companyName: new FormControl("", Validators.required),
          monthlySalaryAmount: new FormControl("0", [Validators.min(0), Validators.required]),
          startDate: new FormControl("", Validators.required),
          workContractType: new FormControl("", Validators.required),
          workDepartmentName: new FormControl("", Validators.required),
          workPosition: new FormControl("", Validators.required),
          country: new FormControl(this.customer.mainPersonalInfo?.nationality, Validators.required),
          deparment: new FormControl("", Validators.required),
          city: new FormControl("", Validators.required),
          neighborhood: new FormControl("", Validators.required),

        }));

        break;
      case 'Z004':
        this.personIncomeInformationForm.setControl("incomeForm", this.fb.group({
          companyType: new FormControl("", this.isShortFormActiveForPlan ? []: [Validators.required]),
          companyName: new FormControl("", Validators.required),
          monthlySalaryAmount: new FormControl("0", [Validators.min(1), Validators.required]),
          startDate: new FormControl("", Validators.required),
          workContractType: new FormControl("", this.isShortFormActiveForPlan ? []: [Validators.required]),
          workDepartmentName: new FormControl("", Validators.required),
          workPosition: new FormControl("", this.isShortFormActiveForPlan ? []: [Validators.required]),
          country: new FormControl(this.customer.mainPersonalInfo?.nationality, Validators.required),
          deparment: new FormControl("", Validators.required),
          city: new FormControl("", Validators.required),
          neighborhood: new FormControl("", Validators.required),
          street: new FormControl("", Validators.required),
          street2: new FormControl(""),
          street3: new FormControl(""),
          street4: new FormControl(""),
          street5: new FormControl(""),
          companyPhone: new FormControl("", this.isShortFormActiveForPlan ? []: [Validators.required]),
          companyExtension: new FormControl(""),
        }));
        break;
      case 'Z005':
        this.personIncomeInformationForm.setControl("incomeForm", this.fb.group({
          incomeType: new FormControl("", Validators.required),
          incomeAmount: new FormControl("0", [Validators.min(1), Validators.required]),
          specify: new FormControl("", Validators.required),
          receivingDate: new FormControl("", Validators.required)
        }))
        break;
      case 'Z006':
        this.personIncomeInformationForm.setControl("incomeForm", this.fb.group({
          companyType: new FormControl(""),
          companyName: new FormControl("", Validators.required),
          monthlySalaryAmount: new FormControl("0", [Validators.min(0)]),
          startDate: new FormControl(""),
          workContractType: new FormControl(""),
          workDepartmentName: new FormControl(""),
          workPosition: new FormControl(""),
          country: new FormControl(this.customer.mainPersonalInfo?.nationality, Validators.required),
          deparment: new FormControl("", Validators.required),
          city: new FormControl("", Validators.required),
          neighborhood: new FormControl("", Validators.required),
          street: new FormControl(""),
          street2: new FormControl(""),
          street3: new FormControl(""),
          street4: new FormControl(""),
          street5: new FormControl(""),
          companyPhone: new FormControl("", this.isShortFormActiveForPlan ? []: [Validators.required]),
          companyExtension: new FormControl(""),
        }));
        break;
      case "Z007":
        this.personIncomeInformationForm.setControl("incomeForm", this.fb.group({
          businessName: new FormControl("", this.isShortFormActiveForPlan ? []: [Validators.required]),
          incomeAmount: new FormControl("0", [Validators.min(0)]),
          economicActivity: new FormControl("", Validators.required),
          businessRelationType: new FormControl(""),
          businessRelationDate: new FormControl(""),
          country: new FormControl(this.customer.mainPersonalInfo?.nationality, Validators.required),
          deparment: new FormControl("", Validators.required),
          city: new FormControl("", Validators.required),
          neighborhood: new FormControl("", Validators.required),
          street: new FormControl(""),
          street2: new FormControl(""),
          street3: new FormControl(""),
          street4: new FormControl(""),
          street5: new FormControl(""),
          companyPhone: new FormControl("", Validators.required),
          companyExtension: new FormControl(""),
        }));
        break;
      default:
        this.personIncomeInformationForm.setControl("incomeForm", this.fb.group({}));
        break;
    }
  }

  getIncomeForm() {
    return this.personIncomeInformationForm.get("incomeForm") as FormGroup;
  }


}
